import UploadedFile from "~/records/record.uploaded_file.jsx";
import { createImmutableIsEqualSelector } from "./index.jsx";
import { getFormAttachedUploadedFilesCodes, getFormUnfinishedFileUploadsCodes } from "./selector.forms.jsx";

export const getAllUploadedFiles = (state) => state.uploaded_files;
export const getUploadedFileById = (state, id) => state.uploaded_files.get(`${id}`);
export const getUploadedFileByCode = (state, code) => getAllUploadedFiles(state).get(code, new UploadedFile());

const getUploadedFilesByCodes = (state, codes = []) => {
  return getAllUploadedFiles(state).filter((uploadedFile) => {
    return codes.indexOf(uploadedFile.code) > -1;
  });
};

export const makeUploadedFilesByCodesSelector = () => {
  return createImmutableIsEqualSelector(getUploadedFilesByCodes, (uploadedFiles) => uploadedFiles);
};

export const makeUploadedFilesByFormSelector = () => {
  return createImmutableIsEqualSelector(
    getFormUnfinishedFileUploadsCodes,
    getFormAttachedUploadedFilesCodes,
    getAllUploadedFiles,
    (unfinishedCodes, attachedCodes, uploadedFiles) => {
      const codes = unfinishedCodes.concat(attachedCodes);
      return uploadedFiles.filter((uploadedFile) => {
        return codes.indexOf(uploadedFile.code) > -1;
      });
    }
  );
};
